import { render, staticRenderFns } from "./ModifyName.vue?vue&type=template&id=040fe7f8&scoped=true&"
import script from "./ModifyName.vue?vue&type=script&lang=js&"
export * from "./ModifyName.vue?vue&type=script&lang=js&"
import style0 from "./ModifyName.vue?vue&type=style&index=0&id=040fe7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fe7f8",
  null
  
)

export default component.exports